import { makeLogger } from "@/shared/consola";
import { defineStore } from "pinia";
import { useAsyncState } from "@vueuse/core/index";
import { pageToolsService } from "@/apps/page/services/page-tools.service";
import { InPageUsedTools } from "@/apps/page/page-project.interface";

const STORE_NAME = "tool-projects";
const logger = makeLogger("🍍" + STORE_NAME);

export const useToolProjectsStore = defineStore(STORE_NAME, () => {
    const { state: toolProjects, execute: reloadProjects } = useAsyncState(
        () => pageToolsService.getAllUserToolProjects(),
        pageToolsService.emptyState(),
        {
            immediate: true,
        }
    );

    return {
        toolProjects,
        // actions:
        reloadProjects,
        getProjectsByTool(tool?: InPageUsedTools) {
            logger.trace("getProjectsByTool called", tool);
            return tool ? toolProjects.value[tool] || [] : [];
        },
    };
});
